import type { FindTotpSecretResponse } from '@contexts/auth/domain';
import { TotpRepository } from '@contexts/auth/domain/contracts/totp.repository';
import type { EnvironmentRepository, HttpService, PostResponse } from '@contexts/shared/domain';

export function restApiTotpRepositoryBuilder(
	environment: EnvironmentRepository,
	httpService: HttpService
): TotpRepository {
	return {
		async generateSecret(token: string): Promise<FindTotpSecretResponse> {
			const response = await httpService.post<PostResponse<{ secret: string; qr: string }>>(
				`${environment.apiBaseUrl}/auth/totp/secret`,
				{
					token
				},
				undefined
			);

			return response.data.item;
		},
		async verifyCode(token: string, code: string): Promise<void> {
			await httpService.post<{ token: string }>(
				`${environment.apiBaseUrl}/auth/totp/code`,
				{
					token,
					code
				},
				undefined
			);
		}
	};
}
